import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../api';
import { DashboardStats } from '../../types';
import Loading from '../../components/common/Loading';

const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);

  useEffect(() => {
    adminApi.getDashboard().then(r => setStats(r.data.data));
  }, []);

  if (!stats) return <Loading />;

  const totalRevenue = stats.revenueByRegion.reduce((sum, r) => sum + Number(r.revenue), 0);

  const cards = [
    { label: '총 매출 (USD)', value: `$${totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, icon: '💰', color: '#b39ddb' },
    { label: '전체 주문', value: `${stats.totalOrders}건`, icon: '📋', color: '#ff9800' },
    { label: '취소 주문', value: `${stats.cancelledOrders}건`, icon: '❌', color: '#f44336' },
    { label: '신규 회원', value: `${stats.newUsers}명`, icon: '👥', color: '#2196f3' },
    { label: '지역 수', value: `${stats.revenueByRegion.length}개`, icon: '🌏', color: '#9c27b0' },
  ];

  return (
    <div>
      <h2 style={styles.title}>대시보드</h2>
      <div style={styles.cardGrid}>
        {cards.map(card => (
          <div key={card.label} style={styles.card}>
            <div style={{ ...styles.cardIcon, background: `${card.color}15` }}>{card.icon}</div>
            <div>
              <p style={styles.cardLabel}>{card.label}</p>
              <p style={{ ...styles.cardValue, color: card.color }}>{card.value}</p>
            </div>
          </div>
        ))}
      </div>

      <div style={styles.quickLinks}>
        <h3 style={styles.quickTitle}>빠른 메뉴</h3>
        <div style={styles.quickGrid}>
          {[
            { to: '/admin/products', label: '상품 관리', icon: '📦' },
            { to: '/admin/orders', label: '주문 관리', icon: '📋' },
            { to: '/admin/users', label: '회원 관리', icon: '👥' },
            { to: '/admin/categories', label: '카테고리 관리', icon: '🗂' },
          ].map(item => (
            <Link key={item.to} to={item.to} style={styles.quickCard}>
              <span style={styles.quickIcon}>{item.icon}</span>
              <span style={styles.quickLabel}>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  title: { fontSize: 22, fontWeight: 700, marginBottom: 24 },
  cardGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16, marginBottom: 40 },
  card: { background: '#fff', borderRadius: 12, padding: 20, border: '1px solid #f0f0f0', display: 'flex', gap: 16, alignItems: 'center' },
  cardIcon: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 },
  cardLabel: { fontSize: 12, color: '#888', marginBottom: 4 },
  cardValue: { fontSize: 20, fontWeight: 700 },
  quickLinks: {},
  quickTitle: { fontSize: 16, fontWeight: 700, marginBottom: 16 },
  quickGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 },
  quickCard: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: 24, background: '#fff', borderRadius: 12, border: '1px solid #f0f0f0', cursor: 'pointer', transition: 'box-shadow 0.2s' },
  quickIcon: { fontSize: 32 },
  quickLabel: { fontSize: 14, fontWeight: 500, color: '#333' },
};

export default AdminDashboard;
